import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Trademark } from '@cp/ds/src/components/trademark';
import { Container } from '@cp/ds/src/components/container';
// import loadable from '@loadable/component';
// import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { RoutedLink } from 'src/shared/ui/link';

// NOTE: Temporary disabled (https://yougile.com/team/2c7dacf7a810/#YOU-3509)
// const SpecialistsMenuDesktop = loadable(() => import('./components/specialistsMenuDesktop'));
// const SpecialistsMenuMobile = loadable(() => import('./components/specialistsMenuMobile'));
// const EmployersMenuDesktop = loadable(() => import('./components/employersMenuDesktop'));
// const EmployersMenuMobile = loadable(() => import('./components/employersMenuMobile'));

const LEFT_OFFSET_XL = '-160px';

export const FooterTop: React.FC = () => {
  // const isMobile = useIsMobile();

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: { xs: 2, lg: 5.5 },
          flexDirection: { xs: 'column', lg: 'row' },
          mb: { xs: 0, md: 1.625 },
          position: 'relative',
        }}
      >
        <RoutedLink
          href="/"
          sx={{
            textDecoration: 'none',
            position: { xs: 'relative', xl: 'absolute' },
            display: { md: 'none', lg: 'block' },
            top: { xl: 0 },
            left: { xl: LEFT_OFFSET_XL },
            right: { xl: 0 },
            bottom: { xl: 0 },
          }}
        >
          <Trademark size={2} sx={{ py: { xs: 2, lg: 1 } }} />
        </RoutedLink>
        {/* <Box sx={{ display: 'flex', flexDirection: 'column', width: 1 }}>
          {isMobile ? <SpecialistsMenuMobile /> : <SpecialistsMenuDesktop />}
          {isMobile ? <EmployersMenuMobile /> : <EmployersMenuDesktop />}
        </Box> */}
      </Box>
    </Container>
  );
};
